import { ll_url } from "../../../../utils/tools";
import * as React from "react";

export function LogoHope() {
  const link = "https://www3.cmbi.umcn.nl/hope/";
  return (
    <a href={link} target="_blank" className="ll-logo-link">
      <img src={ll_url('/images/result/hope.png')} style={{
        maxHeight: 'calc(1.2rem + 0.5rem + 5px)',  // section name font size + body top margin + header bottom padding
      }} />
    </a>
  )
}